import { TweenMax, TimelineLite } from 'gsap';
import ScrollMagic from 'scrollmagic';
import ScrollMagicController from '../class/ScrollMagicController';
import { _isUndefined } from 'gsap/gsap-core';
import { initSwipers } from '../utils/functions';
import Device from '../Device';

class BigBanner {
	constructor() {
		this.sections = document.querySelectorAll('.big-banner');
		this.sections.forEach((section) => new Section(section));
	}
}

class Section {
	constructor(section) {
		this.section = section;
		this.slidesContainer = section.querySelector('.big-banner__slides');
		this.video = this.getActiveVideo();
		this.swiper = initSwipers([section], {
			slidesPerView: 1,
			loop: true,
			autoHeight: true,
			on: {
				slideChange: () => {
					if (this.video) this.video.pause();
				},
				slideChangeTransitionEnd: () => {
					this.video = this.getActiveVideo();
					if (this.video && this.video.autoplay) {
						this.video.play();
					}
				},
			},
		});

		this.animate();
		this.handleScroll();
	}

	handleScroll = () => {
		const scene = new ScrollMagic.Scene({
			duration: this.slidesContainer.clientHeight,
			triggerElement: this.slidesContainer,
			reverse: true,
		}).addTo(ScrollMagicController.controller);
		scene.on('enter', () => {
			if (!Device.isMobile() && !Device.isTablet() && this.video && this.video.autoplay) {
				this.video.play();
			}
		});
		scene.on('leave', () => {
			if (!Device.isMobile() && !Device.isTablet() && this.video && this.video.autoplay) {
				this.video.pause();
			}
		});
	};

	getActiveSlide = () => this.section.querySelector('.swiper-slide-active');
	getActiveVideo() {
		const activeSlide = this.getActiveSlide();
		const video = activeSlide ? activeSlide.querySelector('video') : this.section.querySelector('video');

		return video ? new Video(video) : null;
	}

	animate() {
		const title = this.section.querySelectorAll('.title, .surtitle');
		const titleAnimation = TweenMax.staggerFromTo(title, 0.35, { y: 100, autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, 0.3);
		const slides = this.section.querySelector('.swiper-container');
		const slidesAnimation = TweenMax.fromTo(slides, 0.5, { y: 200, autoAlpha: 0 }, { y: 0, autoAlpha: 1 });

		const timeline = new TimelineLite();
		timeline.add(titleAnimation).add(slidesAnimation);

		new ScrollMagic.Scene({
			trigger: this.section,
			triggerHook: 0.85,
			offset: 0,
			reverse: false,
		})
			.setTween(timeline)
			.addTo(ScrollMagicController.controller);
	}
}

class Video {
	constructor(video) {
		this.video = video;
		this.container = video.parentElement;
		this.playButton = this.container.querySelector('.big-banner-video__play');
		this.muteButton = this.container.querySelector('.big-banner-video__mute');
		this.autoplay = video.dataset.autoplay === 'true';
		this.playing = video.paused;
		this.muted = video.muted;

		this.container.addEventListener('click', () => {
			this.autoplay = !this.playing;
			return this.playing ? this.pause() : this.play();
		});

		this.muteButton.addEventListener('click', (ev) => {
			ev.stopPropagation();
			this.video.muted = !this.muted;
			this.muted = this.video.muted;
			this.muteButton.classList.toggle('disabled');
		});
	}

	play() {
		this.video.play();
		this.playing = !this.video.paused;
		this.hidePlayButton();
	}

	pause() {
		this.video.pause();
		this.playing = !this.video.paused;
		this.showPlayButton();
	}

	hidePlayButton = () => (this.playButton.style.display = 'none');
	showPlayButton = () => (this.playButton.style.display = 'block');
}

export default BigBanner;
